/** @format */

import {useState, MouseEvent} from 'react';

import {Popover} from '@mui/material';

import {Root, ValueText} from './styles';
import {LogTooltip} from '../log-tooltip';
import {ScatterButtonData} from '../../../models/scatters';

interface Props {
  buttonData: ScatterButtonData;
}

const LogButton = ({buttonData}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const {value, tooltipData} = buttonData;
  const isZero = value === 0;

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (!isZero) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);
  const id = isOpen ? `note-${tooltipData.startOn}` : undefined;

  return (
    <>
      <Root onClick={handleClick} active={isOpen} disabled={isZero} data-testid='log-button'>
        <ValueText isZero={isZero}>{String(value)}</ValueText>
      </Root>

      <Popover
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              background: 'none',
              boxShadow: 'none',
              overflow: 'visible',
              marginTop: '4px',
            },
          },
        }}
      >
        <LogTooltip data={tooltipData} value={value} />
      </Popover>
    </>
  );
};

export {LogButton};
